import { useFormContext } from 'react-hook-form'
import { Select, TextInput } from '../../common/Form'
import { InputFormProps } from '../Edit/InputForm'
import { AllowUncontrolled } from '../../common/Form/RHF'
const MAX_MAX_BITRATE_AAC = 1000

export const FFmpegParamsInputsAudio = ({ isReshuffling }: { isReshuffling?: boolean }) => {
  const { getValues, watch } = useFormContext<InputFormProps & AllowUncontrolled>()
  const values = getValues()

  watch('deriveFrom.ingestTransform.ffmpegParams.audioCodec')

  const wantedTransformType = isReshuffling ? 'audio-reshuffling' : 'transcode'

  const ffmpegParams =
    values?.deriveFrom?.ingestTransform?.type === wantedTransformType
      ? values?.deriveFrom?.ingestTransform.ffmpegParams
      : undefined

  const isAudioCodec = !!ffmpegParams?.audioCodec
  const isAac = ffmpegParams?.audioCodec === 'aac'
  const isAacQuality = !!ffmpegParams?.audioAacQuality

  return (
    <>
      <Select
        label="Audio codec"
        name="deriveFrom.ingestTransform.ffmpegParams.audioCodec"
        options={[
          ...(!isReshuffling ? [{ name: 'Keep original', value: '' }] : []),
          { name: 'AAC', value: 'aac' },
          { name: 'MP2', value: 'mp2' },
          { name: 'AC3', value: 'ac3' },
        ]}
        tooltip={!isReshuffling ? 'Change audio codec' : 'Output audio codec will be applied to all reshuffled streams'}
        required={isReshuffling}
      />

      {isAudioCodec && (
        <TextInput
          label="Audio Bitrate (kbps)"
          name="transcodeAudioBitrateKbps"
          noNegative
          validators={{
            number: {
              lessThanOrEqualTo: MAX_MAX_BITRATE_AAC,
              greaterThan: 0,
              message: `Must be greater than zero and no more than ${MAX_MAX_BITRATE_AAC}`,
            },
          }}
          type="number"
          disabled={isAacQuality}
        />
      )}

      {isAac && (
        <>
          <Select
            label="AAC Profile"
            name="deriveFrom.ingestTransform.ffmpegParams.audioAacProfile"
            options={[
              { name: 'LC', value: 'LC' },
              { name: 'HE', value: 'HE' },
              { name: 'HEv2', value: 'HEv2' },
            ]}
          />

          <Select
            label="AAC Quality"
            name="deriveFrom.ingestTransform.ffmpegParams.audioAacQuality"
            options={[
              { name: 'Disable', value: '' },
              { name: 'Low', value: 'low' },
              { name: 'Medium', value: 'medium' },
              { name: 'High', value: 'high' },
            ]}
            tooltip="Uses a variable bitrate target. Overrides the constant bitrate setting chosen in: Audio Bitrate (kbps)"
          />
        </>
      )}
    </>
  )
}
